/**
 * Pluralizes a given string based on the specified condition.
 * @function pluralize
 * @param {string} string - The string to pluralize.
 * @param {boolean} isPlural - Whether the string should be pluralized.
 * @returns {string} The pluralized string if isPlural is true, otherwise the original string.
 */
export const pluralize = (string: string, isPlural: boolean) => {
  if (!isPlural) return string;

  const lowerCasedString = string.toLowerCase();
  console.log('🚀 ~ pluralize ~ lowerCasedString:', lowerCasedString);

  // Handle words that end in 'y'
  if (
    lowerCasedString.endsWith('y') &&
    !['a', 'e', 'i', 'o', 'u'].includes(
      lowerCasedString[lowerCasedString.length - 2] || '',
    )
  ) {
    return preserveCapitalization(
      string,
      lowerCasedString.slice(0, -1) + 'ies',
    );
  }

  // Handle words that end in 's', 'x', 'z', 'ch', or 'sh'
  if (
    ['s', 'x', 'z'].includes(
      lowerCasedString[lowerCasedString.length - 1] || '',
    ) ||
    ['ch', 'sh'].some((suffix) => lowerCasedString.endsWith(suffix))
  ) {
    console.log('here');
    return preserveCapitalization(string, lowerCasedString + 'es');
  }

  // Handle irregular nouns
  const irregularNouns: { [key: string]: string } = {
    child: 'children',
    man: 'men',
    woman: 'women',
    tooth: 'teeth',
    foot: 'feet',
    mouse: 'mice',
    person: 'people',
  };

  if (irregularNouns[lowerCasedString]) {
    return preserveCapitalization(string, irregularNouns[lowerCasedString]);
  }

  // Default pluralization rule
  return preserveCapitalization(string, lowerCasedString + 's');
};

/**
 * Helper function to preserve the original capitalization.
 * @function preserveCapitalization
 * @param {string} original - The original string.
 * @param {string} modified - The modified string.
 * @returns {string} The modified string with preserved capitalization.
 */
const preserveCapitalization = (original: string, modified: string) => {
  if (original === original.toUpperCase()) {
    return modified.toUpperCase();
  } else if (original[0] && original[0] === original[0].toUpperCase()) {
    return modified.charAt(0).toUpperCase() + modified.slice(1);
  } else {
    return modified;
  }
};
